export const entity = {
  invOverview: {
    name: 'Inventory Overview',
    overStock: 'Overstock',
    safetyStock: 'Safety Stock',
    outOfStock: 'Out of Stock',
  },
};
